module.exports = __webpack_public_path__ + "img/home-background.af1d91c7.svg";